import { useEffect } from "react";
import { landingPageService } from "service/landing-page/service";

const Landing = () => {
  const getMember = async () => {
    try {
      const result = await landingPageService.getMemberList();
      console.log("mnemnber", result);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getMember();
  }, []);
  return (
    <div
      style={{ marginLeft: "17.125rem", display: "flex", flexDirection: "column", padding: "24px" }}
    >
      <div>랜딩페이지 리스트</div>
    </div>
  );
};

export default Landing;
